export default __webpack_public_path__ + "static/media/eth.c740e7e3.webp";